import { forwardRef, ForwardRefExoticComponent, useMemo } from 'react';

import {
  Checkbox as MantineCheckbox,
  CheckboxProps,
  CheckboxCard,
  CheckboxIndicator
} from '@mantine/core';

import { useMergeClassNames } from '../../utils';

import {
  CheckboxOverridesClassNames,
  CheckboxVarsResolver
} from './Checkbox.styles';
import { CheckboxGroup } from './CheckboxGroup';

type CheckboxComponent = ForwardRefExoticComponent<
  CheckboxProps & React.RefAttributes<HTMLInputElement>
> & {
  Group: typeof CheckboxGroup;
  Card: typeof CheckboxCard;
  Indicator: typeof CheckboxIndicator;
};

const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>((props, ref) => {
  const { classNames, ...rest } = props;

  const classes = useMemo(() => {
    return CheckboxOverridesClassNames();
  }, [props]);

  const mergedClassNames = useMergeClassNames({
    classNames: [classNames, classes]
  });

  return (
    <MantineCheckbox
      {...rest}
      vars={CheckboxVarsResolver}
      ref={ref}
      classNames={mergedClassNames}
    />
  );
}) as CheckboxComponent;

Checkbox.Group = CheckboxGroup;

export { Checkbox };
export type { CheckboxProps };
